import { t } from "@lingui/macro";
import MainSportQuestion from "../Onboarding/TrainingPreferences/MainSportQuestion";
import useTrainingPreferences from "./useTrainingPreferences";
import { Box, Container } from "@mui/material";
import { ErrorBoundary, GlobalHeader } from "@WahooFitness/wahoo-offline-mfe";

const TrainingPreferences: React.FC = () => {
  const { sportOptionListItems } = useTrainingPreferences();
  const title = t`Preferred sport`;

  return (
    <Container maxWidth="sm" disableGutters sx={{ minHeight: "100%" }}>
      <ErrorBoundary isLoading={false} error={false} onReload={() => {}}>
        <GlobalHeader title={title} />
        <Box pt={2}>
          <MainSportQuestion sportOptionListItems={sportOptionListItems} />
        </Box>
      </ErrorBoundary>
    </Container>
  );
};

export default TrainingPreferences;
